import $ from "jquery"

window.$ = $
window.jQuery = $
import is from "is_js"

window.is = is
import "slick-carousel"
import "slick-carousel/slick/slick.css"
import "selectize/dist/js/selectize.min.js"
import Swiper, {Navigation, Pagination, Lazy, EffectFade, Autoplay, A11y} from "swiper"

Swiper.use([Navigation, Pagination, Lazy, EffectFade, Autoplay, A11y])

import "./main-sliders.js"
import "./vinery.js"
import "./faq.js"
import "./tabs.js"

import "./standart-page.js"
import "./notification.js"
// import Sticky from "./x-widgets.js"
import "./comment-files.js"
// import "./header-showing.js"
import initCatalogColumns from "./catalogColumns.js"
import initShowHint from "./showHint";
import initNewSearch from "./newSearch.js"
import hideBreadcrumbs from "./hideBreadcrumbs.js"
import "./img.upload.js"
import "./manufacture.js"
import initAnimations, {Animation, Animations} from "./animations.js"
import initStartVideo from "./startVideo";
import initIframeVideos from "./iframeVideos";
import "./new-main.js"
import Tabs from "./new-tabs.js"
import {initToastTesting} from "./toast-testing";
import {initQuizBlock} from "./quiz-block";
import {initAnniversary} from "./new-design/initAnniversary";


const WOW = require("wowjs").WOW

// require("./loupe.js");
require("./countTo.js")
require("./jquery.fancybox.js")
require("../css/jquery.fancybox.css")

function heightBtnTextSlider() {
    $(".main-slider__info-cont .main-slider__info").height(
        Math.max(
            ...$(".main-slider__info-cont .main-slider__info").map(function () {
                return $(this).height()
            }),
        ),
    )

    var mainSliderInfoHeight = $(".main-slider__info").outerHeight()
    var mainSliderInfoWidth = $(".main-slider__info").innerWidth()
    var mainSliderNavWidth = $(".main-slider__nav").innerWidth()
    // console.log(mainSliderInfoHeight,mainSliderInfoWidth,mainSliderNavWidth)

    $(".main-slider__nav").css({
        bottom: $(".main-slider").height() / 2 - $(".main-slider__info").height() / 2 - $(".main-slider__nav").height() * 2 - 5,
        left: mainSliderInfoWidth - mainSliderNavWidth,
    })
}

document.addEventListener("DOMContentLoaded", (e) => {
    initToastTesting();
    initQuizBlock();

    const zoomers = document.querySelectorAll(".zoomer")
    if (zoomers.length !== 0 && document.body.classList.contains("admin")) {
        zoomers.forEach((img) => {
            let loup = new Loupe(img)
        })
    }
    new Tabs()
    hideBreadcrumbs()
    initCatalogColumns()
    initAnimations()
    initNewSearch()
    initStartVideo()
    initShowHint()
    initIframeVideos()
    initAnniversary()

    // BLOG CONTACTS DROPDOWN

    if (window.matchMedia("(max-width: 667px)").matches) {
        let button = document.querySelector(".blog-contacts__title")
        if (button) {
            button.addEventListener("click", () => {
                button.classList.toggle("active")
            })
        }
    }

    $(".basket-fly-cont").hover(
        function () {
            $("body").addClass("basket-hover")
        },
        function () {
            $("body").removeClass("basket-hover")
        },
    )

    $(".blog-contacts__item-top").click(function () {
        $(this).closest(".blog-contacts__item").toggleClass("active")
        $(this).siblings(".blog-contacts__item-bot").slideToggle()
    })

    $("div.blog-filter__item-top").click(function () {
        $(this).closest(".blog-filter__item").toggleClass("active")
        $(this).siblings(".blog-filter__item-bot").slideToggle()
    })

    document.querySelectorAll(".id-order").forEach((el) =>
        el.addEventListener("click", () => {
            if (document.querySelector(".id-order")) el.closest(".item").classList.toggle("active")
        }),
    )

    if ($(window).width() < 667) {
        $(".order-date").click(function () {
            setTimeout(function () {
                $("html,body").animate({scrollTop: $(".order-form__calendar").offset().top - 80}, 1000)
            }, 300)
        })
    }

    $(".collection-info__item-top").click(function () {
        $(this).siblings(".collection-info__item-bot").slideToggle()
        $(this).toggleClass("js__open")
    })

    heightBtnTextSlider()

    function headHeight() {
        if (!$("body").hasClass("main") && !$("body").hasClass("page-personal-franchise")) {
            var heightError = $(".found-error").innerHeight()

            $(".found-error").siblings("header").css({
                top: heightError,
            })
        }
    }

    headHeight()

    if ($(".title, .title-block h1").length) {
        $(".title, .title-block h1").each(function () {
            var article_text = $(this).html().replace(/-/gi, "<span>-</span>")
            $(this).html(article_text)
        })
    }

    var elements = document.getElementsByClassName("catalog-two__item-img")
    var i
    for (i = 0; i < elements.length; i++) {
        var offset = elements[i].clientHeight * 0.7 //.5 = 50%
        elements[i].setAttribute("data-wow-offset", offset)
    }

    new WOW({
        boxClass: "wow", // default
        animateClass: "animated", // default
        offset: 0, // default
        mobile: true, // default
        live: false, // default
    }).init()

    new WOW({
        boxClass: "catalog-one__item-img", // default
        animateClass: "animated", // default
        offset: 50, // default
        mobile: true, // default
        live: false, // default
    }).init()

    if (is.ios()) {
        $("body").addClass("js__ios")
    }

    $(".filter-panel").click(function () {
        var $this = $(this)
        $this.next("form").slideToggle()
    })

    let mobileMenu = $(".head-menu__list").clone(),
        mobileSoc = $("footer .soc").clone(),
        mobileLk = $("header .menu-lk").clone(),
        mobileTel = $("header .head-phone").clone()

    $(".mobile-menu").append(mobileLk)
    $(".mobile-menu").append(mobileMenu)
    $(".mobile-menu").append(mobileSoc)
    $(".mobile-menu").append(mobileTel)

    $("body").click(function (e) {
        if (!$(e.target).is($(".mobile-menu")) && !$(".mobile-menu").has(e.target).length && $("body").hasClass("js__menu--open") && !$(e.target).is($(".burger")) && !$(".burger").has(e.target).length) {
            $("body").removeClass("js__menu--open");
            document.querySelector('.burger').classList.remove('opened');
        }
    })

    new Swiper(".card-slider .swiper-list", {
        effect: "fade",
        slidesPerView: 1,
        loop: false,
        roundLengths: true,
        speed: 2000,
        autoplay: true,
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: ".card-slider .swiper-button-next",
            prevEl: ".card-slider .swiper-button-prev",
        },
    })

    // $(".default-slider-cont").each(function (i, el) {
    //     let $this = $(el)

    //     let defaultSlider = new Swiper($this.find(".swiper-list"), {
    //         slidesPerView: 3,
    //         loop: false,
    //         roundLengths: true,
    //         speed: 1000,
    //         autoplay: true,
    //         spaceBetween: 20,
    //         navigation: {
    //             nextEl: $this.find(".swiper-button-next"),
    //             prevEl: $this.find(".swiper-button-prev"),
    //         },
    //         breakpoints: {
    //             660: {
    //                 slidesPerView: 1,
    //             },
    //             1000: {
    //                 slidesPerView: 2,
    //             },
    //         },
    //     })
    // })

    // default-slider
    let defaultSliders = document.querySelectorAll(".default-slider-cont")
    if (defaultSliders.length) {
        defaultSliders.forEach((slider) => {
            let swiper = new Swiper(slider.querySelector('.swiper-list'), {
                slidesPerView: 1,
                loop: false,
                roundLengths: true,
                speed: 1000,
                autoplay: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: slider.querySelector(".swiper-button-next"),
                    prevEl: slider.querySelector(".swiper-button-prev"),
                },
                breakpoints: {
                    420: {
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 3,
                    },
                },
            })
        })
    }

    $("body").on("click", ".btn--filter, .btn--close", function () {
        $("body").toggleClass("js__filter-open")
    })

    $("body").on("click", ".filter__title", function () {
        let $this = $(this)

        $this.closest(".filter__item").toggleClass("active")
    })

    let swiper = new Swiper(".main-slider .swiper-container", {
        effect: "fade",
        slidesPerView: 1,
        loop: false,
        roundLengths: true,
        speed: 2000,
        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    })

    let newMainSlider = new Swiper(".new-main-slider .swiper-container", {
        effect: "fade",
        slidesPerView: 1,
        loop: false,
        roundLengths: true,
        speed: 2000,
        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    })

    let totalMainSlider = $(".new-main-slider .swiper-slide:not(.swiper-slide-duplicate)").length

    if (totalMainSlider <= 1) {
        $(".new-main-slider__nav").remove()
    }

    let swiperFranchiseAbout = new Swiper(".franshiza-company__slider .swiper-container", {
        effect: "fade",
        slidesPerView: 1,
        // loop: true,
        autoplay: true,
        a11y: false,
        roundLengths: true,
        navigation: {
            nextEl: ".franshiza-company__slider .swiper-container .swiper-button-next",
            prevEl: ".franshiza-company__slider .swiper-container .swiper-button-prev",
        },
    })

    let swiperFranshizaProduct = new Swiper(".franshiza-product__slider .swiper-container", {
        // effect: "fade",
        slidesPerView: 3,
        loop: true,
        roundLengths: true,
        spaceBetween: 3,
        // freeMode: true,
        a11y: false,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            660: {
                slidesPerView: 2,
                spaceBetween: 3,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 3,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 3,
            },
        },

        navigation: {
            nextEl: ".franshiza-product__arrow .swiper-button-next",
            prevEl: ".franshiza-product__arrow .swiper-button-prev",
        },
    })

    var swiperFranshizaReviews = new Swiper(".franshiza-reviews-cont:not(.reviews-client) .swiper-container", {
        slidesPerView: 1,
        loop: false,
        roundLengths: true,
        spaceBetween: 3,
        autoHeight: true,
        // autoplay: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            660: {
                slidesPerView: 3,
                spaceBetween: 3,
            },
        },
        navigation: {
            nextEl: ".franshiza-reviews-cont:not(.reviews-client) .franshiza-reviews__arrow .swiper-button-next",
            prevEl: ".franshiza-reviews-cont:not(.reviews-client) .franshiza-reviews__arrow .swiper-button-prev",
        },
        on: {
            slideNextTransitionStart() {
                $(".swiper-slide").find(".franshiza-reviews__item.js__open-text").removeClass("js__open-text")
            },
            slidePrevTransitionStart() {
                $(".swiper-slide").find(".franshiza-reviews__item.js__open-text").removeClass("js__open-text")
            },
        },
    })

    var sliderBot = new Swiper(".slider-bot .swiper-list", {
        slidesPerView: 1,
        loop: true,
        roundLengths: true,
        spaceBetween: 20,
        autoplay: true,
        navigation: {
            nextEl: ".slider-bot .swiper-button-next",
            prevEl: ".slider-bot .swiper-button-prev",
        },
    })

    $("body").on("click", ".franshiza-reviews-cont:not(.reviews-client) .franshiza-reviews__item .btn", function () {
        let $this = $(this)

        $this.closest(".franshiza-reviews-cont:not(.reviews-client) .franshiza-reviews__item").toggleClass("js__open-text")

        const parentSlider = $this.closest(".swiper-container")[0].swiper

        setTimeout(function () {
            parentSlider.updateAutoHeight()
        }, 100)
    })

    $(".franshiza-reviews-cont:not(.reviews-client) .franshiza-reviews__item").each(function (i, el) {
        var $this = $(el),
            franshizaTitleHeight = $this.find(".franshiza-reviews__item-title").height(),
            franshizaCityHeight = $this.find(".franshiza-reviews__item-city").height(),
            franshizaTextHeight = $this.find(".franshiza-reviews__item-text").height(),
            franshizaMediaHeight = $this.find(".franshiza-reviews__item-media").height(),
            franshizaDateHeight = $this.find(".franshiza-reviews__item-data").height()

        var totalHeight = franshizaTitleHeight + franshizaCityHeight + franshizaDateHeight
        var finishHeight = $this.find(".franshiza-reviews__item-media").height() - totalHeight - 21

        if (franshizaTextHeight > franshizaMediaHeight) {
            $this.find(".franshiza-reviews__item-text").css({
                height: finishHeight,
                overflow: "hidden",
            })
        }
        const parentSlider = $this.closest(".swiper-container")[0].swiper
        setTimeout(function () {
            parentSlider.updateAutoHeight()
        }, 110)
    })

    var swiperFranshizaReviewsClient = new Swiper(".reviews-client .franshiza-reviews__list .swiper-container", {
        slidesPerView: 5,
        loop: true,
        roundLengths: true,
        spaceBetween: 3,
        autoHeight: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            660: {
                slidesPerView: 2,
                spaceBetween: 3,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 3,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 3,
            },
            1600: {
                slidesPerView: 5,
                spaceBetween: 3,
            },
        },
        navigation: {
            nextEl: ".reviews-client .franshiza-reviews__arrow .swiper-button-next",
            prevEl: ".reviews-client .franshiza-reviews__arrow .swiper-button-prev",
        },
    })

    $("body").on("click", ".reviews-client .franshiza-reviews__item .btn", function () {
        let $this = $(this)

        $this.closest(".reviews-client .franshiza-reviews__item").toggleClass("js__open-text")
        $this.closest(".reviews-client .franshiza-reviews__item").find(".answer").slideToggle(300)

        const parentSlider = $this.closest(".swiper-container")[0].swiper

        let interval = setInterval(function () {
            parentSlider.updateAutoHeight()
        }, 10)

        setTimeout(function () {
            clearInterval(interval)
        }, 300)
    })

    let swiperFranshizaEvents = new Swiper(".franshiza-events__list .swiper-container", {
        slidesPerView: 3,
        loop: true,
        roundLengths: true,
        spaceBetween: 45,

        navigation: {
            nextEl: ".franshiza-events__arrow .swiper-button-next",
            prevEl: ".franshiza-events__arrow .swiper-button-prev",
        },
    })

    let swiperTestemonials = new Swiper(".account-testemonials__slider .swiper-container", {
        effect: "fade",
        navigation: {
            nextEl: ".account-testemonials__arrow .swiper-button-next",
            prevEl: ".account-testemonials__arrow .swiper-button-prev",
        },
    })

    $(".burger").click(function () {
        $("body").toggleClass("js__menu--open")
    })

    //SEARCH======================================================================
    $(".nm-header__mobile-search").click(function () {
        $("body").toggleClass("js__search--open");
        const input = document.querySelector('.m-menu__search-input');
        if (input) input.focus();
    })

    $(".m-menu__search-btn").click(function () {
        $("body").removeClass("js__search--open")
    })
    //======================================================================

    $(".head-menu__item").find("ul").closest("li").addClass("js__has-submenu")

    $('input[type="file"]').change(function () {
        var value = $(this)[0].files[0].name
        $(this).siblings(".forms__input--file-support").val(value)
    })

    if ($("body").hasClass("page-personal-franchise")) {
        var list = document.querySelector("#filial__list")

        if (list) {
            window.observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    let input = mutation.addedNodes[0].querySelector(".forms-input-cont--file:first-child:nth-last-child(2) .forms__input--file")

                    console.log(mutation, input)

                    if (input) input.addEventListener("change", InputFileChange)
                })
            })

            observer.observe(list, {
                attributes: false,
                childList: true,
                characterData: false,
            })
        }

        $("body").on("change", ".forms__input--file", function (e) {
            var value = $(this)[0].files[0].name
            var inputHasFile = $(this).next('input[type="text"]').val(value)

            if (inputHasFile.length) {
                $(this).nextAll("label").remove()
            }
        })

        $("body").on("click", ".filial__item-el .add-input", function () {
            var time = +new Date(),
                $this = $(this),
                getName = $(this).closest(".forms__input-cont--multiple").find(".forms__input-cont:first-child input").attr("name")

            var inputBlock = $this.closest(".forms__input-cont--multiple").append('<div class="forms__input-cont">\
					<input type="text" id="' + time + '" name="' + getName + '"  class="forms__input">\
					<span class="js__input-del" title="Удалить"></span>\
				</div>')
        })

        $("body").on("click", ".filial__item-el--photo .add-input", function () {
            var time = +new Date()
            var $this = $(this)
            var getName = $(this).closest(".forms__input-cont--multiple").find(".forms__input-cont:first-child input").attr("name")

            var inputBlock = $this
                .closest(".forms__input-cont--multiple")
                .append(
                    '<div class="forms__input-cont forms-input-cont--file">\
					<input class="forms__input forms__input--file" name="' +
                    getName +
                    '" type="file" id="' +
                    time +
                    '" accept="image">\
                <input class="forms__input forms__input--file-support" readonly="" type="text">\
                <label class="forms__label--file" for="' +
                    time +
                    '"></label>\
                <span class="js__input-del" title="Удалить"></span>\
            </div>',
                )

            let newInput = inputBlock.find(".forms-input-cont--file:last-child input[type='file']")[0]

            newInput.addEventListener("change", InputFileChange)
        })

        window.InputFileChange = function () {
            if (this.files[0]) {
                var fr = new FileReader(),
                    $shopBlock = $(this).closest("div[data-id]")

                console.log($shopBlock)

                fr.addEventListener(
                    "load",
                    (e) => {
                        let $photos = $shopBlock.find(".filial-load-photo")

                        $photos.append("<img src='" + fr.result + "' />")
                    },
                    false,
                )

                fr.readAsDataURL(this.files[0])
            }
        }

        if ($(".filial__item-el--photo input[type='file']").length) document.querySelector(".filial__item-el--photo input[type='file']").addEventListener("change", InputFileChange)

        $("body").on("click", ".filial__item-el--photo .input-del", function () {
            let $this = $(this).closest(".forms-input-cont--file"),
                $cont = $(this).closest(".filial__item-el--photo"),
                index = $this.index()

            console.log(index, $this)
            console.log($cont)

            $cont
                .nextAll(".filial-load-photo")
                .find("img:eq(" + index + ")")
                .remove()
        })

        $("body").on("click", ".js__input-del, .input-del", function () {
            var $this = $(this)

            $this.closest(".forms__input-cont").remove()
        })
    }
    $(".tovar__item-top").click(function () {
        let $this = $(this)

        $this.toggleClass("js__open")
        $this.siblings(".tovar__item-cont").slideToggle()
    })

    $('.head-notficator__icon').click(function () {
        let $this = $(this)
        $this.parent('.head-notficator').toggleClass("open")
    })

    $('.head-notficator__close').click(function () {
        $('.head-notficator').toggleClass("open")
    })

    $(".bh-body__item-top").click(function () {
        let $this = $(this)

        $this.toggleClass("js__open")
        $this.siblings(".bh-body__item-cont").slideToggle()
    })

    $(".reviews__item .btn").click(function () {
        let $this = $(this)
        $this.closest(".reviews__item").toggleClass("js__reviews-open")
    })

    $(".reviews__item").each((i, el) => {
        let $this = $(el)

        let itemHeight = $this.find(".reviews__item-text").height()

        console.log(itemHeight)
        if (itemHeight < 150) {
            $this.find(".btn").remove()
        }
    })

    $("body").on("click", ".account-testemonials__item--right .btn", function () {
        let $this = $(this)

        $this.closest(".account-testemonials__item").toggleClass("js__open-text")
        $this.closest(".account-testemonials__item").find(".answer").slideToggle()
    })

    $(".submenu").each((i, el) => {
        let $this = $(el)

        $this.closest(".head__menu-item").addClass("js__has-submenu")
    })

    if ($(".statistic__num").length) {
        $(".statistic__num").countTo()
    }

    $(window).on("scroll", function () {
        if ($(".statistic__num").length)
            if ($(".statistic__num").offset().top + 50 <= $(window).scrollTop() + $(window).height()) {
                $(".statistic__num:not(.countered)").each((i, el) => {
                    let $this = $(el),
                        speed = 0

                    switch (i) {
                        case 0:
                            speed = 4000
                            break
                        case 1:
                            speed = 2000
                            break

                        default:
                            speed = 3000
                    }

                    $this.countTo({
                        speed: speed,
                    })

                    $this.addClass("countered")
                })
            }
    })

    $("body").on("click change", ".btn-clear", function () {
        $(this).prevAll('input[type="text"]').val("")
    })

    function injector(t, splitter, klass, after) {
        var a = t.text().split(splitter),
            inject = ""
        if (a.length) {
            $(a).each(function (i, item) {
                if ($("div").hasClass("intro-bg__text")) {
                    // inject += '<span class="'+klass+'" \
                    // style="transition-delay: '+(0.12 * i)+'s; transform: translate3d(0, '+(0.30 * i)+'%, 0);">'+item+'</span>'+after;
                    inject += '<span class="' + klass + (i + 1) + '" \
					style="transition-delay: ' + 0.05 * i + "s; transform: translate3d(0, " + 15.3 * i + '%, 0);">' + item + "</span>" + after
                }

                // let deleayCounter = a.length - i;
                // inject += '<span class="'+klass+(i+1)+'" \
                // style="transition-delay: '+(0.12 * deleayCounter)+'s; transform: translate3d('+(0.30 * i)+'%, 0, 0);">'+item+'</span>'+after;
            })
            t.empty().append(inject)
        }
    }

    var methods = {
        init: function () {
            return this.each(function () {
                injector($(this), "", "char", "")
            })
        },

        words: function () {
            return this.each(function () {
                injector($(this), " ", "word", " ")
            })
        },

        lines: function () {
            return this.each(function () {
                var r = "eefec303079ad17405c889e092e105b0"
                // Because it's hard to split a <br/> tag consistently across browsers,
                // (*ahem* IE *ahem*), we replaces all <br/> instances with an md5 hash
                // (of the word "split").  If you're trying to use this plugin on that
                // md5 hash string, it will fail because you're being ridiculous.
                injector($(this).children("br").replaceWith(r).end(), r, "line", "")
            })
        },
    }

    $.fn.lettering = function (method) {
        // Method calling logic
        if (method && methods[method]) {
            return methods[method].apply(this, [].slice.call(arguments, 1))
        } else if (method === "letters" || !method) {
            return methods.init.apply(this, [].slice.call(arguments, 0)) // always pass an array
        }
        $.error("Method " + method + " does not exist on jQuery.lettering")
        return this
    }

    $(".intro-bg__text").lettering()

    $(".fancybox").fancybox({
        trapFocus: false,
        touch: false,
        buttons: ["fullscreen", "slideShow", "close"],
        image: {
            preload: true,
        },
        transitionEffect: "slide",
    })

    if ($(window).width() <= 1200) {
        $(".head-menu__item.js__has-submenu").each(function (i, el) {
            var $this = $(el),
                setCloneLink = $this.find("ul").prev("a").clone()

            $this.find("ul").prepend('<li class="head-menu__item js__link-parent"></li>')
            $this.find(".js__link-parent").prepend(setCloneLink)
            $this.find("ul").prepend('<div class="head-menu__item js__back">Назад</div>')
        })

        $(".head-menu__item.js__has-submenu > a").removeAttr("href")
        $(".head-menu__item.js__has-submenu > a").click(function () {
            var $this = $(this)
            $this.closest("body").addClass("js__submenu--open")
        })

        $(".js__back").click(function () {
            var $this = $(this)
            $this.closest("body").removeClass("js__submenu--open")
        })
    }

    if ($(window).width() <= 667) {
        $(".vino-mobile .item").each(function (i, el) {
            let $this = $(el)

            $this.find(".text-page p").closest(".item").addClass("js__has-content")
        })

        $(".vino-title").click(function () {
            let $this = $(this)

            $this.toggleClass("js__open")
            $this.next(".vino-content").slideToggle()
        })
    }

    selectizeInit()

    let catalogTagsLength = $('.catalog-tags__item').length;
    if(catalogTagsLength > 5) {
        let catalogTagsMore = catalogTagsLength - 5;
        $('.catalog-tags').append('<a class="catalog-tags__item show-more">еще <span>+ '+catalogTagsMore+'</span></a>');
        $('.catalog-tags .show-more').click(function() {
            $(this).parent('.catalog-tags').addClass('open');
        })

    }

    function initDropdownAbout() {
        const dropdownAbout = document.querySelector('.dropdown-about');
        const dropdownAboutTrigger = dropdownAbout.querySelector('.dropdown-about__trigger');
        // const dropdownAboutContent = dropdownAbout.querySelector('.dropdown-about__content');

        const activeClass = 'active';

        dropdownAboutTrigger.addEventListener('click', () => {
            if (!dropdownAbout.classList.contains(activeClass))
                dropdownAbout.classList.add(activeClass);
            else
                dropdownAbout.classList.remove(activeClass);
        })
    }

    // initDropdownAbout();
})

window.selectizeInit = function () {
    if ($(window).width() > 1000) {
        $("select:not(.no-selectize)").each(function (i, el) {
            let $this = $(el)

            $this.selectize({
                create: true,
            })
        })
    }
}

$(window).on("resize", (e) => {
    heightBtnTextSlider()
})

$(window).on("load scroll resize touchmove", (e) => {
    if (document.querySelector("body.page-about")) {
        $(".history__intro").remove()
        $("body").addClass("js__history-animate")
    }

    if ($(window).width() > 660 && $("body").hasClass("main")) {
        if ($(window).scrollTop() >= 250) {
            $(".head").addClass("js__scrolled")
            $("body").addClass("js__scroll")

            setTimeout((e) => {
                $(".head").addClass("js__show")
            }, 200)
        } else {
            $(".head").removeClass("js__scrolled").removeClass("js__show")
            $("body").removeClass("js__scroll")
        }
    } else if ($("body").hasClass("main")) {
        if ($("body").hasClass("js__menu--open")) {
            return false
        }

        if ($(window).scrollTop() <= 0) {
            $(".head").removeClass("js__scrolled").removeClass("js__show")
            $("body").removeClass("js__scroll")
        } else {
            $(".head").addClass("js__scrolled")
            $("body").addClass("js__scroll")

            setTimeout((e) => {
                $(".head").addClass("js__show")
            }, 200)
        }
    }
})

// Оформить резерв
// $(window).on('load', () => {
//     window.setTimeout(function () {
//         $('body').addClass('loaded')
//     }, 1500);
// })




// WEBPACK FOOTER //
// ./src/js/common.js